import { gql } from '@apollo/client';
import gqlClient from '../../../../utils/apolloClient';

const insertStationMutation = gql`
  mutation ($object: emergency_roles_insert_input!) {
    insert_emergency_roles_one(object: $object) {
      id
    }
  }
`;

export const createStation = async (variables: object) => {
  const res = await gqlClient.mutate<{
    insert_emergency_roles_one: {
      id: string,
    }
  }>({ mutation: insertStationMutation!, variables });
  return res.data?.insert_emergency_roles_one.id;
}
